module.exports = "/_next/static/images/postponed-67b73140c447a4d54e66c1642f63cba4.png";